export default {
    PERCENT_DOSE_NOT_EXIST: "درصد وارد نشده است.",
    PERCENT_INVALID: "درصد نامعتیر است.",
  
    BASE_PRICE_DOSE_NOT_EXIST: "مبلغ پایه وارد نشده است.",
    BASE_PRICE_INVALID: "مبلغ پایه نامعتیر است.",
  
    PRICE_DOSE_NOT_EXIST: "مبلغ وارد نشده است.",
    PRICE_INVALID: "مبلغ نامعتیر است.",
  
    WIDTH_DOSE_NOT_EXIST: "عرض وارد نشده است.",
    WIDTH_INVALID: "عرض نامعتیر است.",
  
    HEIGHT_DOSE_NOT_EXIST: "ارتفاع وارد نشده است.",
    HEIGHT_INVALID: "ارتفاع نامعتیر است.",
  
    ACTIVE_INVALID: "فعال بودن نامعتبر است.",
  };
  